import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiZap } = FiIcons;

const Hero = () => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const bgImage = "https://img.gedhemedia.com/HeroSection_GedheMediaCo.jpeg";

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-cover bg-right-top bg-no-repeat"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 hero-mask z-0"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="max-w-4xl">
          <div className="space-y-8 md:space-y-10">
            <div className="inline-flex items-center px-4 py-2 bg-orange-600/30 border border-orange-500/40 rounded-full backdrop-blur-md">
              <SafeIcon icon={FiZap} className="text-orange-400 mr-2" />
              <span className="text-orange-50 font-black text-xs md:text-sm tracking-widest uppercase">Strategic Growth Partner</span>
            </div>
            
            <h1 className="text-4xl md:text-7xl lg:text-8xl font-black text-white leading-[1.1] drop-shadow-2xl">
              Bantu Bisnis Lokal <br />
              <span className="gradient-text">Tumbuh Konsisten</span>
            </h1>
            
            <div className="space-y-6">
              <p className="text-lg md:text-2xl text-gray-100 max-w-2xl leading-relaxed font-bold drop-shadow-md">
                GedheMedia membantu bisnis lokal lebih mudah ditemukan, mendapatkan leads berkualitas, dan bekerja lebih efisien melalui sistem digital yang tepat.
              </p>
              <p className="text-orange-400 text-lg md:text-xl font-black italic border-l-4 border-orange-500 pl-4">
                Bukan sekadar bikin website. Kami membangun mesin pertumbuhan digital untuk bisnis Anda.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 md:gap-6 pt-4">
              <a 
                href="https://wa.me/6283128418389" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary inline-flex items-center justify-center px-8 md:px-10 py-4 md:py-5 text-white font-black rounded-2xl text-lg md:text-xl transition-transform hover:scale-105 active:scale-95 shadow-2xl"
              >
                Konsultasi Gratis via WhatsApp <SafeIcon icon={FiArrowRight} className="ml-2 text-xl" />
              </a>
              <a 
                href="#process" 
                onClick={(e) => scrollToSection(e, 'process')} 
                className="btn-secondary inline-flex items-center justify-center px-8 md:px-10 py-4 md:py-5 font-black rounded-2xl text-lg md:text-xl transition-transform hover:scale-105 active:scale-95"
              >
                Lihat Cara Kerja Kami
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;